import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { enhance } from './enhance';
import { APP_VERSION, CI_PIPELINE_IID } from '../../../constants/env';
import brandConfig from '../../../constants/brandConfig';
import TermsAndConditions from '../../TermsAndConditions';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import { usePageView } from '../../../hocs/usePageView';

import styles from '../index.styl';

const Support = ({
  supportInfo,
  platformVersion,
  loggedUserCountry,
  intl: { formatMessage },
}) => {
  usePageView('Profile | Support');
  const { name, email, phoneNumber } = supportInfo;
  const needHelp = formatMessage({ id: 'support.needHelp' }, { name });

  const version = useMemo(() => [APP_VERSION, CI_PIPELINE_IID].join('.'), []);

  return (
    <div className={styles.supportWrapper}>
      <MetaHelmet title="pages.title.profile.support" />
      <div className={styles.supportBlock}>
        <h3 className={styles.supportTitle}>
          {formatMessage({ id: 'support.helpCenter' })}
        </h3>
        <div className={styles.supportQuestion}>{needHelp}</div>
        <div className={styles.supportContacts}>
          <span className={styles.supportLable}>
            {formatMessage({ id: 'common.phone' })}
          </span>
          <p className={styles.supportText}>{phoneNumber}</p>
        </div>
        <span className={styles.supportLable}>
          {formatMessage({ id: 'fields.email' })}
        </span>
        <a className={styles.supportText} href={`mailto:${email}`}>
          {email}
        </a>
      </div>
      <div className={styles.supportBlock}>
        <h3 className={styles.supportTitle}>
          {formatMessage({ id: 'googleMaps.about' })}
        </h3>
        <div className={styles.supportContacts}>
          <span className={styles.supportLable}>
            {formatMessage({ id: 'profile.fields.name' })}
          </span>
          <p className={styles.supportText}>{brandConfig.name}</p>
        </div>
        <div className={styles.supportContacts}>
          <span className={styles.supportLable}>
            {formatMessage({ id: 'support.appVersion' })}
          </span>
          <p className={styles.supportText}>{version}</p>
        </div>
        <div className={styles.supportContacts}>
          <span className={styles.supportLable}>
            {formatMessage({ id: 'support.platformVersion' })}
          </span>
          <p className={styles.supportText}>{platformVersion}</p>
        </div>
      </div>
      <TermsAndConditions
        country={loggedUserCountry}
        additionalStyles={styles.termsAdditionalStyles}
      />
    </div>
  );
};

Support.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  supportInfo: PropTypes.object,
  platformVersion: PropTypes.string,
  loggedUserCountry: PropTypes.string,
};

export default enhance(Support);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/Support/index.jsx